import React from 'react';
import styles from './Footer.module.scss';
import { getClassName } from '@onsolve/utils.get-class-name';
import { t } from '@lingui/macro';
const Footer = () => {
    // const { themeLogo } = useThemeContext();
    const [rootClass, getChildClass] = getClassName({
        rootClass: 'footer',
        styles,
    });
    return (<footer className={rootClass}>
            <div className="onsolve-footer__copyright">
                <span>&copy; {new Date().getFullYear()} OnSolve</span>
            </div>

            <div className={getChildClass('right')}>
                <ul className={getChildClass('links-list')}>
                    <li role="menuitem" className={getChildClass('links-item')}>
                        <a className="onsolve-footer__link" target={'_blank'} href={'https://www.onsolve.com'} rel="noreferrer">
                            www.onsolve.com
                        </a>
                    </li>
                    <li role="menuitem" className={getChildClass('links-item')}>
                        <a className="onsolve-footer__link" target={'_blank'} href={'/'} rel="noreferrer">
                            {t `EU Privacy Request`}
                        </a>
                    </li>
                    <li role="menuitem" className={getChildClass('links-item')}>
                        <a className="onsolve-footer__link" target={'_blank'} href={'/'} rel="noreferrer">
                            {t `Privacy Statement`}
                        </a>
                    </li>

                    <li role="menuitem" className={getChildClass('links-item')}>
                        <a className="onsolve-footer__link" target={'_blank'} href={'https://www.onsolve.com/company/privacy/privacy-statement'} rel="noreferrer">
                            {t `Copyright Notice`}
                        </a>
                    </li>
                    <li role="menuitem" className={getChildClass('links-item')}>
                        <a className="onsolve-footer__link" target={'_blank'} href={'/'} rel="noreferrer">
                            {t `Contact Us`}
                        </a>
                    </li>
                </ul>
            </div>
        </footer>);
};
export default Footer;
